function parseDigits(string: string, match: RegExp) {
  return (string.match(match) || []).join("");
}

export function formatSimCode(value: string, match: RegExp, separator: string) {
  const digits = [...parseDigits(value, match)].entries();
  let result = "";

  for (const [index, digit] of digits) {
    if (index === 19) {
      return result;
    }
    if (index === 4 || index === 8 || index === 12 || index === 16) {
      result = `${result}${separator}`;
    }
    result = `${result}${digit}`;
  }

  return result;
}
